import InfoItems from './InfoItems'
export default InfoItems
